import { Box, Typography } from '@mui/material';
import React from 'react';
import { i18n } from '../../i18n/i18n';
import { WatchList } from '../CustomInfoCard/infoBlock';
import { COLORS, Tooltip } from '@cellebrite/saas-ui-common';
import { getWatchListIcon } from '../../utils/utils';
import Popup from '../Popup/Popup';
import CustomList from '../CustomList/CustomList';

interface ViewWatchListsProps {
    watchLists?: WatchList[];
}

const ViewWatchLists: React.FC<ViewWatchListsProps> = ({ watchLists }) => {
    const icon = getWatchListIcon();

    return watchLists?.length ? (
        <Tooltip
            styles={{ maxWidth: 223 }}
            placement="right"
            content={
                <Box
                    sx={{ display: 'flex', flexDirection: 'column', rowGap: 2, p: 1, width: 212 }}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <Typography
                        variant="s12w700"
                        className="color-bd"
                    >{`${watchLists?.length} ${i18n.translate('Watchlist Matches:')}`}</Typography>
                    <Box sx={{ overflow: 'auto', maxHeight: 198, display: 'flex', flexDirection: 'column', rowGap: 2 }}>
                        {watchLists.map((watchList, index) => (
                            <Box key={index}>
                                <Typography variant="s12w700" className="color-md">
                                    {`${watchList.watchlistDisplayName} (${watchList.keywords?.length})`}
                                </Typography>
                                <CustomList
                                    styles={{ my: 0.5 }}
                                    gap={{ width: 0.5, height: 0.5 }}
                                    list={watchList.keywords?.map((keyword, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                backgroundColor: COLORS.MUTED_SOFT,
                                                px: 0.5,
                                                borderRadius: '4px',
                                                height: 20,
                                            }}
                                        >
                                            <Typography variant="s12w700" className="color-bd">
                                                {keyword}
                                            </Typography>
                                        </Box>
                                    ))}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            }
        >
            {icon}
        </Tooltip>
    ) : (
        icon
    );
};

export default ViewWatchLists;
